/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Tab } from 'semantic-ui-react'
import { NavLink, Route, Routes } from 'react-router-dom-v5-compat'
import OrdersFinished from './OrdersFinished'
import OrdersUntreated from './OrdersUntreated'
import { useTranslation } from 'react-i18next'
import useMediaQuery from 'beautiful-react-hooks/useMediaQuery'
import { MOBILE_THRESHOLD } from '../../constants'
import { isProviderAPos } from '../../services/Provider/Provider.service'
import OrdersCurrent from './OrdersCurrent'
import useUser from '../Shared/UserProvider/useUser'

const OrdersLists = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const isMobile = useMediaQuery(`(max-width: ${MOBILE_THRESHOLD}px)`)
    const prefix = isMobile ? '.mobile' : ''

    const panes = [{
        menuItem: {
            as: NavLink,
            id: 'finished',
            content: t(`order${prefix}.finished`),
            to: '/orders/finished',
            key: 'finished',
        },
        pane: (
          <Routes>
              <Route
                path="finished"
                key="finished"
                element={<OrdersFinished />}
              />
          </Routes>
        ),
    }, {
        menuItem: {
            as: NavLink,
            id: 'untreated',
            content: t(`order${prefix}.untreated`),
            to: '/orders/untreated',
            key: 'untreated',
        },
        pane: (
          <Routes>
              <Route
                path="untreated"
                key="untreated"
                element={<OrdersUntreated />}
              />
          </Routes>
        ),
    }]

    if (isProviderAPos(user.provider)) {
        panes.unshift({
            menuItem: {
                as: NavLink,
                id: 'current',
                content: t(`order${prefix}.current`),
                to: '/orders/current',
                key: 'current',
            },
            pane: (
              <Routes>
                  <Route
                    path="current"
                    key="current"
                    element={<OrdersCurrent />}
                  />
              </Routes>
            ),
        })
    }

    return (
      <Tab
        css={css`margin: 20px 0;`}
        renderActiveOnly={false}
        activeIndex={-1}
        panes={panes}
        menu={{secondary: true, pointing: true, className: 'wrapped'}}
      />
    )
}

export { OrdersLists }
